var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"caption round-medium shadow-huge card left-text"},[_c('router-link',{staticClass:"d-block",attrs:{"to":_vm.link}},[_c('img',{staticClass:"caption-image ",attrs:{"src":'images/mpower-new/'+_vm.image}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }